import { Injectable, WritableSignal, signal } from '@angular/core';

export type StriaAlertType =
    | 'primary'
    | 'accent'
    | 'warn'
    | 'basic'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';

export type ToastPosition =
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'top-center'
    | 'bottom-center';

type ToastMessage = {
    message: string;
    type: StriaAlertType;
    position: ToastPosition;
    visible: boolean;
};

@Injectable({ providedIn: 'root' })
export class ToastService {
    toast: WritableSignal<ToastMessage | null> = signal(null);

    /**
     *  Show toast message with type & position
     */
    showToast(
        message: string,
        type: StriaAlertType = 'info',
        position: ToastPosition = 'top-center'
    ): void {
        this.toast.set({ message, type, position, visible: true });

        // Auto-hide after 3 seconds
        setTimeout(() => this.hideToast(), 3000);
    }

    /**
     *  Hide toast message
     */
    hideToast(): void {
        this.toast.set(null);
    }
}
